import { render, staticRenderFns } from "./warrantyStyle.vue?vue&type=template&id=180c1331&scoped=true"
import script from "./warrantyStyle.vue?vue&type=script&lang=js"
export * from "./warrantyStyle.vue?vue&type=script&lang=js"
import style0 from "./warrantyStyle.vue?vue&type=style&index=0&id=180c1331&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180c1331",
  null
  
)

export default component.exports